import { AuthState } from "@/vuex/auth/types";

export const state: AuthState = {
  user: null,
  acountServices: [],
  isLogged: false,
  loading: false,
  accessToken: "",
  redirectTo: "",
  userPermissions: null,
  appId: ""
};
